import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "public-project-page"
}
const _hoisted_2 = { class: "hero-content" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "brand-text"
}
const _hoisted_5 = { class: "headline" }
const _hoisted_6 = {
  key: 2,
  class: "description"
}
const _hoisted_7 = {
  key: 3,
  class: "buttons-row"
}
const _hoisted_8 = ["href", "target", "rel"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "btn-label" }
const _hoisted_11 = {
  key: 4,
  class: "buttons-row"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["href"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 2,
  class: "loading"
}
const _hoisted_17 = {
  key: 3,
  class: "not-found"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!$setup.loading.value && $setup.pageData.estateId && $setup.isLandSubdivision)
    ? (_openBlock(), _createBlock($setup["LandSubdivisionPublicProjectPage"], {
        key: 0,
        pageData: $setup.pageData
      }, null, 8, ["pageData"]))
    : (!$setup.loading.value && $setup.pageData.estateId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "hero-bg",
            style: _normalizeStyle($setup.heroBgStyle)
          }, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "hero-overlay" }, null, -1)),
            _createElementVNode("div", _hoisted_2, [
              ($setup.displayContent.logoImageUrl)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "logo-img",
                    src: $setup.displayContent.logoImageUrl,
                    alt: "Logo"
                  }, null, 8, _hoisted_3))
                : ($setup.displayContent.brandText)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString($setup.displayContent.brandText), 1))
                  : _createCommentVNode("", true),
              _createElementVNode("h1", _hoisted_5, _toDisplayString($setup.displayContent.headline), 1),
              ($setup.displayContent.description)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($setup.displayContent.description), 1))
                : _createCommentVNode("", true),
              ($setup.visibleButtons.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.visibleButtons, (btn, i) => {
                      return (_openBlock(), _createElementBlock("a", {
                        key: i,
                        class: "action-btn",
                        href: $setup.getButtonHref(btn.destination),
                        target: btn.destination === 'map' ? '_self' : '_blank',
                        rel: btn.destination === 'map' ? '' : 'noopener noreferrer'
                      }, [
                        _createElementVNode("span", {
                          class: "btn-icon",
                          innerHTML: $setup.getButtonIcon(btn.destination)
                        }, null, 8, _hoisted_9),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(btn.label), 1)
                      ], 8, _hoisted_8))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("a", {
                      class: "action-btn",
                      href: $setup.getButtonHref('home')
                    }, [
                      _createElementVNode("span", {
                        class: "btn-icon",
                        innerHTML: $setup.getButtonIcon('home')
                      }, null, 8, _hoisted_13),
                      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "btn-label" }, "Explore Homes", -1))
                    ], 8, _hoisted_12),
                    _createElementVNode("a", {
                      class: "action-btn",
                      href: $setup.getButtonHref('map')
                    }, [
                      _createElementVNode("span", {
                        class: "btn-icon",
                        innerHTML: $setup.getButtonIcon('map')
                      }, null, 8, _hoisted_15),
                      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "btn-label" }, "View Estate Map", -1))
                    ], 8, _hoisted_14)
                  ]))
            ])
          ], 4)
        ]))
      : ($setup.loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("p", null, "Loading...", -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("p", null, "Project page not found", -1)
          ]))]))
}